import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LOCALE, readStoredLocale } from "./constants";

/**
 * ⚠️⚠️ **ENG MUHIM ARXITEKTURA QARORI (P7 spec §6).** Namespace resurslari
 * `import.meta.glob` orqali AVTOMATIK yig'iladi — hech qanday qo'lda
 * yozilgan `NAMESPACES` ro'yxati YO'Q.
 *
 * Sabab: har modul o'zining `locales/uz/<nom>.json` va `locales/ru/<nom>.json`
 * juftligini qo'shadi (13+ parallel agent), lekin hech biri BOSHQA faylni
 * (masalan markaziy ro'yxat) tahrirlamaydi. Markaziy ro'yxat bo'lganda
 * bularning barchasi bitta faylni bir vaqtda tahrirlab, bir-birining
 * qo'shgan qatorini poyga holatida yo'qotib qo'yardi — bu fayl esa
 * hech qachon tahrirlanmaydi, yangi namespace shunchaki YANGI fayl.
 *
 * ⚠️ Bu SATR sabab bu modul `bun test` ostida IMPORT QILINMAYDI (statik
 * ham, boshqa modul orqali ham) — `import.meta.glob` faqat Vite build/dev
 * vaqtida haqiqiy funksiyaga aylanadi, `bun test` Vite orqali o'tmaydi
 * va uni chaqirish `TypeError: import.meta.glob is not a function` bilan
 * yiqiladi. Yagona chaqiruvchi — `main.tsx` (yon ta'sir importi).
 * `useChangeLocale`, `AntdProvider` kabi sinov qamroviga tushadigan
 * fayllar `i18next` paketining o'zidan (shu bir xil singleton) yoki
 * `react-i18next`ning `useTranslation()`idan foydalanadi — bu modulni
 * IMPORT QILMAYDI.
 */
const modules = import.meta.glob("./locales/*/*.json", { eager: true }) as Record<
	string,
	{ default: Record<string, unknown> }
>;

const FILE_PATTERN = /\.\/locales\/([a-z]{2})\/([\w-]+)\.json$/;

type ResourceTree = Record<string, Record<string, Record<string, unknown>>>;

function buildResources(): { resources: ResourceTree; namespaces: string[] } {
	const resources: ResourceTree = {};
	const namespaces = new Set<string>();

	for (const [path, mod] of Object.entries(modules)) {
		const match = path.match(FILE_PATTERN);
		if (!match) {
			continue;
		}

		const [, lang, namespace] = match;
		resources[lang] ??= {};
		resources[lang][namespace] = mod.default;
		namespaces.add(namespace);
	}

	return { resources, namespaces: [...namespaces] };
}

const { resources, namespaces } = buildResources();
const initialLocale = readStoredLocale();

i18next.use(initReactI18next).init({
	lng: initialLocale,
	fallbackLng: DEFAULT_LOCALE,
	ns: namespaces,
	// ⚠️ `defaultNS` ATAYLAB "common" — standart i18next qiymati
	// ("translation") bizda mavjud emas (§8dagi 25 namespace ro'yxatida
	// yo'q). Buni belgilamasak, namespace'siz `t("kalit")` chaqiruvi
	// (masalan `useTranslation()` — argumentsiz) jimgina "kalit"ning
	// o'zini qaytarardi. 13+ parallel agent shu infratuzilma ustiga
	// quradi — keyinroq o'zgartirish ularning yozgan `t()` chaqiruvlarini
	// buzadi, shuning uchun BOSHIDANOQ qat'iy belgilanadi.
	defaultNS: "common",
	fallbackNS: "common",
	resources,
	interpolation: { escapeValue: false },
	// Ilova ichida to'liq qatordagi apostrof (`'`) ko'p ishlatiladi —
	// i18next standart kalit ajratuvchisi `:` va `.` bilan to'qnashmaydi,
	// lekin xavfsizlik uchun aniq yozamiz.
	keySeparator: ".",
	nsSeparator: ":",
});

export default i18next;
export { initialLocale };
